import ngRedux from 'ng-redux';

import config from './config';
import run from './run';

export default angular
  .module('app.store', [ngRedux])
  .config(['$ngReduxProvider', config])
  .run(['$ngRedux', '$state', '$mdToast', '$translate', '$mdDialog', run]);
